import { Color } from '@anov/3d-core'

const CircleShader = {
  uniforms: {
    iTime: { value: 0.0 },
    color: { value: new Color(1.0, 1.0, 1.0) }, // 添加颜色uniform，默认白色
  },
  vertexShader: `
  varying vec2 vUv;
  #include <common>
  #include <logdepthbuf_pars_vertex>
  void main()
  {
  //#include <begin_vertex>
  // #include <project_vertex>
  vUv = uv;
  vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
  gl_Position = projectionMatrix * mvPosition;
  #include <logdepthbuf_vertex>
  }
  `,
  fragmentShader: `
      varying vec2 vUv;
      uniform float iTime;
      uniform vec3 color;
      #include <logdepthbuf_pars_fragment>
  
      void main() {
        #include <logdepthbuf_fragment>
        //*sin(mod(iTime,100.));  //*fract(mod(iTime,100.))
        float progress=fract(mod(iTime,100.))*0.5;
        float circleOutMax=step(distance(vUv,vec2(0.5,0.5)),0.5); 
        float circleOut=step(distance(vUv,vec2(0.5,0.5)),progress); 
        float circleIn=step(distance(vUv,vec2(0.5,0.5)),progress-0.05); 
        gl_FragColor = vec4(color * (circleOut-circleIn),(0.55-progress)*(circleOut-circleIn)*2.0);
      }
  `,
}

export default CircleShader